import { logger, buildErrorContext } from "../config/telemetry";

/**
 * Register window-level handlers that forward any error escaping React
 * (uncaught runtime errors and unhandled promise rejections) to Rapid7.
 *
 * ErrorBoundary catches errors thrown during React rendering; these handlers
 * cover everything else (event handlers, timers, async code, promises).
 */
let installed = false;

const describeReason = (reason) => {
  if (reason?.message) return reason.message;
  if (typeof reason === "string") return reason;
  try {
    return JSON.stringify(reason);
  } catch {
    return String(reason);
  }
};

export const installGlobalErrorHandlers = () => {
  if (installed || typeof window === "undefined") {
    return;
  }
  installed = true;

  // Uncaught runtime errors (throws outside the React render tree).
  window.addEventListener("error", (event) => {
    const error = event?.error;
    logger.error("uncaught.error", {
      ...buildErrorContext(),
      type: "UncaughtError",
      source: "window.onerror",
      error_desc: error?.message || event?.message,
      error_stack: error?.stack,
      file: event?.filename,
      line: event?.lineno,
      column: event?.colno,
    });
  });

  // Unhandled promise rejections (rejected promises with no .catch).
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event?.reason;
    logger.error("unhandled.rejection", {
      ...buildErrorContext(),
      type: "UnhandledRejection",
      source: "window.onunhandledrejection",
      error_desc: describeReason(reason),
      error_stack: reason?.stack,
    });
  });
};
